import { render } from "./select.html?vue&type=template&id=ba4f0ce6&ts=true"
import script from "./select.ts?vue&type=script&lang=ts"
export * from "./select.ts?vue&type=script&lang=ts"

import "./select.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__